import React, { useContext } from "react";
import { Card, Flex, Link, Text } from "@jsq/ds/core";
import { SubscriptionStatus } from "apps/pillars/SubscriptionDocumentsPillar/constants";
import { SubscriptionStatusAmoeba } from "apps/common/Subscriptions/constants";
import { StaffReviewerRow } from "../StaffReviewerRow";
import { SubscriptionStaffReviewContextState } from "../context";
import { LoadingSpinner } from "./LoadingSpinner";
import { RowSeparator } from "./RowSeparator";
import { SubscriptionReviewerDecision } from "../constants";
import { ManualCompleteStaffReviewBanner } from "../ManualCompleteStaffReviewBanner";

interface Props {
  prospectId: number;
  canStartStaffReview: boolean;
}

export function StaffReviewCard({
  prospectId,
  canStartStaffReview,
}: Props): React.ReactElement {
  const { data, loading, staffReviewCompleted } = useContext(
    SubscriptionStaffReviewContextState,
  );
  const reviewersExist = (data?.subscription?.reviewers.length || 0) > 0;
  const reviewers = reviewersExist
    ? data?.subscription?.reviewers
    : data?.subscription?.reviewerSettings;
  const allReviewersHaveApproved =
    reviewersExist &&
    data?.subscription?.reviewers.every(
      (reviewer) => reviewer.decision === SubscriptionReviewerDecision.Approve,
    );
  const shouldShowManualCompleteBanner =
    !staffReviewCompleted &&
    allReviewersHaveApproved &&
    (data?.subscription?.status === SubscriptionStatus.StaffReview ||
      data?.subscription?.status === SubscriptionStatusAmoeba.AwaitingStaffReview);

  return (
    <Card className="stacked-lg">
      <Flex flexDirection="column" gap={20}>
        <Text variant="h3">Staff review</Text>
        <div>
          {loading && (
            <>
              <RowSeparator />
              <LoadingSpinner />
              <RowSeparator />
            </>
          )}
          {!loading && shouldShowManualCompleteBanner && <ManualCompleteStaffReviewBanner />}
          {!loading &&
            reviewers?.map((reviewer, i) => (
              <React.Fragment key={reviewer.staffUser.id}>
                {i === 0 && <RowSeparator />}
                <StaffReviewerRow
                  reviewer={reviewer}
                  canStartStaffReview={canStartStaffReview}
                />
                <RowSeparator />
              </React.Fragment>
            ))}
        </div>
        <Link href={`/prospect/${prospectId}`} align="left">
          View activity
        </Link>
      </Flex>
    </Card>
  );
}
